import router from './router'
import { getToken } from '@/utils/auth'
import { autoUrlToken } from '@/utils/judge'

router.beforeEach(async(to, from, next) => {
  var token = null
  token = await autoUrlToken// 瑞嘉，带accountId和Token
  token = getToken()
  next()
  if (token) {
    next()
  }
})
// router.afterEach((to, from) => {
//   document.title = i18n('routerBase.' + to.meta.title)
//   // if (!window.entryUrl) {
//   //   window.entryUrl = location.href
//   // }
// })
